<div class="migration-hist">
  @if (loading) {
<div class="mig-hist-loader-container flex-center">
    <i class="fa fa-spinner fa-spin mig-hist-loader gtw-red"></i>
    <span>Table loading...</span>
  </div>
}

  @if (!loading) {
<div class="table-container">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Migration ID</th>
          <th>Tax Year</th>
          <th>Tax Payer</th>
          <th>System</th>
          <th>Status</th>
          <th>Migrated By</th>
          <th>Migrated On</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index) {
<tr>
          <td>{{ row.migration_id }}</td>
          <td>{{ row.tax_year }}</td>
          <td>{{ row.tax_payer }}</td>
          <td>{{ row.system_id }}</td>
          <td>{{ row.status }}</td>
          <td>{{ row.migrated_by }}</td>
          <td>{{ row.migrated_on }}</td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
